/** Device HTTP API surface (versioned for fleets with mixed player builds). */
export const DEVICE_API_PREFIX = '/v1/device';
export const DEVICE_SYNC_PATH = `${DEVICE_API_PREFIX}/sync`;
export const DEVICE_TIME_PATH = `${DEVICE_API_PREFIX}/time`;
export const DEVICE_MANIFEST_PATH = `${DEVICE_API_PREFIX}/manifest`;
export const DEVICE_COMMAND_ACK_PATH = `${DEVICE_API_PREFIX}/commands/ack`;
export const DEVICE_PAIRING_PATH = `${DEVICE_API_PREFIX}/pairing`;
export const DEVICE_PAIRING_SESSIONS_PATH = `${DEVICE_API_PREFIX}/pairing/sessions`;
export const DEVICE_PLAYBACK_EVENTS_PATH = `${DEVICE_API_PREFIX}/playback-events`;
export const DEVICE_WALL_READY_PATH = `${DEVICE_API_PREFIX}/wall-ready`;
//# sourceMappingURL=constants.js.map